import { useDraftMoveSignal } from '../../../rx/signal/useDraftMoveSignal'
import { useHoveredPositionSignal } from '../../../rx/signal/useHoveredPositionSignal'
import type { Engine } from '../engine/Engine.type'
import type { EntityGridXYV2 } from '../tile_position_xy/EntityGridXYV2.type'
import findMostEfficientPathToTileV2 from '../tile_position_xy/findMostEfficientPathToTileV2/findMostEfficientPathToTileV2'
import { samePosition } from '../tile_position_xy/samePosition'

export default function calculateDestPositionHoverPositionPaths(
  engine: Engine,
  entityGridXY: EntityGridXYV2,
): void {
  // console.log('calculateDestPositionHoverPositionPaths')
  const [getDraftMove] = useDraftMoveSignal(engine)
  const draftMove = getDraftMove()
  if (draftMove) {
    const [getHoveredPosition] = useHoveredPositionSignal(engine)
    const { state } = engine
    const hoveredPosition = getHoveredPosition()
    const { destPosition } = draftMove
    draftMove.destPositionPaths = null
    draftMove.hoveredPositionPaths = null
    // draftMove.rangedAttackPaths = null
    if (destPosition || hoveredPosition) {

      const { unit } = draftMove
      const { width, height } = state

      if (destPosition) {
        draftMove.destPositionPaths = findMostEfficientPathToTileV2(
          entityGridXY,
          unit,
          width,
          height,
          destPosition.x,
          destPosition.y
        )
      }
      if (hoveredPosition) {
        if (samePosition(hoveredPosition, destPosition)) {
          draftMove.hoveredPositionPaths = draftMove.destPositionPaths
        } else {
          draftMove.hoveredPositionPaths = findMostEfficientPathToTileV2(
            entityGridXY,
            unit,
            width,
            height,
            hoveredPosition.x,
            hoveredPosition.y
          )
        }
      }
    }
  }
}
